import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';

export default function NavBar() {
  const [loggedIn, setLoggedIn] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);
  const location = useLocation();
  const isMap = location.pathname === '/';

  useEffect(() => {
    setLoggedIn(!!localStorage.getItem('evapp_token'));
    setOpen(false);
  }, [location]);

  useEffect(() => {
    const h = () => setScrolled(window.scrollY > 10);
    window.addEventListener('scroll', h);
    return () => window.removeEventListener('scroll', h);
  }, []);

  const logout = () => { localStorage.removeItem('evapp_token'); window.location.href = '/'; };
  const solid = !isMap || scrolled || open;

  const NavLink = ({ to, children }) => (
    <Link to={to} style={{
      padding: '6px 10px', borderRadius: 8, fontSize: 13, fontWeight: 500,
      color: location.pathname === to ? 'var(--teal)' : 'var(--text-2)',
      textDecoration: 'none',
      background: location.pathname === to ? 'var(--teal-dim)' : 'transparent',
      whiteSpace: 'nowrap', transition: 'all 0.15s',
    }}>{children}</Link>
  );

  const links = [
    { to: '/leaderboard', label: '🏆 Leaderboard', always: true },
    { to: '/premium',     label: '⭐ Premium',     always: true },
    { to: '/invite',      label: '🎁 Invite',      auth: true },
    { to: '/profile',     label: '👤 Profile',     auth: true },
  ].filter(l => l.always || (l.auth && loggedIn));

  return (
    <>
      <nav style={{
        position: 'fixed', top: 0, left: 0, right: 0, zIndex: 2000, height: 56,
        background: solid ? 'rgba(255,255,255,0.97)' : 'rgba(255,255,255,0.5)',
        backdropFilter: 'blur(16px)',
        borderBottom: solid ? '1px solid var(--border)' : 'none',
        display: 'flex', alignItems: 'center', justifyContent: 'space-between',
        padding: '0 16px', transition: 'all 0.25s',
      }}>
        <Link to="/" style={{ textDecoration: 'none', display: 'flex', alignItems: 'center', gap: 8 }}>
          <div style={{ width: 28, height: 28, borderRadius: 8, background: 'linear-gradient(135deg,#00D4AA,#0099FF)', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 14 }}>⚡</div>
          <span style={{ fontWeight: 700, fontSize: 16, color: 'var(--text-1)', letterSpacing: '-0.3px' }}>
            Charge<span style={{ color: 'var(--teal)' }}>Sure</span>
          </span>
        </Link>

        {/* Desktop */}
        <div className="nav-desktop" style={{ display: 'flex', alignItems: 'center', gap: 2 }}>
          {links.map(l => <NavLink key={l.to} to={l.to}>{l.label}</NavLink>)}
          {loggedIn
            ? <button onClick={logout} style={{ marginLeft: 6, padding: '6px 12px', borderRadius: 8, border: '1px solid var(--border-2)', background: 'none', color: 'var(--text-3)', fontSize: 13, cursor: 'pointer' }}>Log out</button>
            : <Link to="/login" style={{ marginLeft: 6, padding: '7px 16px', borderRadius: 8, background: 'linear-gradient(135deg,#00D4AA,#0099FF)', color: 'white', fontSize: 13, fontWeight: 700, textDecoration: 'none' }}>Sign in</Link>
          }
        </div>

        {/* Hamburger */}
        <button className="nav-mobile" onClick={() => setOpen(o => !o)} style={{ background: 'none', border: 'none', cursor: 'pointer', color: 'var(--text-1)', fontSize: 20, padding: 8, lineHeight: 1 }}>
          {open ? '✕' : '☰'}
        </button>
      </nav>

      {/* Mobile dropdown */}
      {open && (
        <div style={{
          position: 'fixed', top: 56, left: 0, right: 0, zIndex: 1999,
          background: 'rgba(255,255,255,0.98)', backdropFilter: 'blur(16px)',
          borderBottom: '1px solid var(--border)', padding: '10px 12px 14px',
          display: 'flex', flexDirection: 'column', gap: 2,
        }}>
          {links.map(l => (
            <Link key={l.to} to={l.to} style={{
              padding: '12px 14px', borderRadius: 10, fontSize: 14, fontWeight: 500,
              color: location.pathname === l.to ? 'var(--teal)' : 'var(--text-1)',
              textDecoration: 'none',
              background: location.pathname === l.to ? 'var(--teal-dim)' : 'transparent',
            }}>{l.label}</Link>
          ))}
          <div style={{ height: 1, background: 'var(--border)', margin: '6px 0' }} />
          {loggedIn
            ? <button onClick={logout} style={{ padding: '12px 14px', borderRadius: 10, border: 'none', background: 'none', color: 'var(--text-3)', fontSize: 14, cursor: 'pointer', textAlign: 'left' }}>Log out</button>
            : <Link to="/login" style={{ padding: '12px 14px', borderRadius: 10, background: 'linear-gradient(135deg,#00D4AA,#0099FF)', color: 'white', fontWeight: 700, textAlign: 'center', textDecoration: 'none', fontSize: 14 }}>Sign In</Link>
          }
        </div>
      )}

      <style>{`
        .nav-desktop { display: flex !important; }
        .nav-mobile  { display: none  !important; }
        @media (max-width: 640px) {
          .nav-desktop { display: none  !important; }
          .nav-mobile  { display: block !important; }
        }
      `}</style>
    </>
  );
}
